import { render } from "./QuestaoOpcaoVisualizacao.vue?vue&type=template&id=2b463171&scoped=true&ts=true"
import script from "./QuestaoOpcaoVisualizacao.vue?vue&type=script&lang=ts"
export * from "./QuestaoOpcaoVisualizacao.vue?vue&type=script&lang=ts"

import "./QuestaoOpcaoVisualizacao.vue?vue&type=style&index=0&id=2b463171&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b463171"]])

export default __exports__